import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import TeamSubteamMembersLayout from 'team/components/subteams/members/TeamSubteamMembersLayout';
import TeamSubteamMembersContent from 'team/components/subteams/members/TeamSubteamMembersContent';

const TeamSubteamMembersDashboard = ({ user, team, subteamId }) => {
    const [searchParams] = useSearchParams();
    const [selectedItem, setSelectedItem] = useState('editMembers');

    // Handle URL tab parameter - select integrations tab if tab=integrations is in URL
    useEffect(() => {
        const tab = searchParams.get('tab');
        if (!tab) return;
        const allowedTabs = new Set([
            'editMembers',
            'general',
            'restrictions',
            'templateAutoAssign',
            'integrations',
            'viewMembers'
        ]);
        if (allowedTabs.has(tab)) {
            setSelectedItem(tab);
        }
    }, [searchParams]);

    const handleMenuItemClick = (item) => {
        setSelectedItem(item);
    };

    return (
        <TeamSubteamMembersLayout
            onMenuItemClick={handleMenuItemClick}
            selectedItem={selectedItem}
            mainContent={
                <TeamSubteamMembersContent
                    selectedItem={selectedItem}
                    subteamId={subteamId}
                />
            }
        />
    );
};

export default TeamSubteamMembersDashboard;

